import React from 'react';

const EnglishFlag = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 36"
    width={size}
    height={(size * 3) / 5}
    {...props}
  >
    <clipPath id="a">
      <path d="M0 0h60v36H0z" />
    </clipPath>
    <clipPath id="b">
      <path d="M30 18h30v18H30z" />
    </clipPath>
    <g clipPath="url(#a)">
      <path d="M0 0v36h60V0z" fill="#012169" />
      <path d="M0 0l60 36m-60 0L60 0" stroke="#fff" strokeWidth="6" />
      <path
        d="M0 0l60 36m-60 0L60 0"
        clipPath="url(#b)"
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path d="M30 0v36M0 18h60" stroke="#fff" strokeWidth="10" />
      <path d="M30 0v36M0 18h60" stroke="#C8102E" strokeWidth="6" />
    </g>
  </svg>
);

export default EnglishFlag; 